import clsx from 'clsx';
import React from 'react';
import { SelectOption, SelectProps } from './Select.types';

export const Select = (props: SelectProps): JSX.Element => {
  const {
    options,
    inputLabel,
    hintText,
    status,
    inputSize,
    formElementClassNames,
    hasFloatingLabel,
    theme,
    ...inputProps
  } = props;

  // Form Element Wrapper Classes
  const formElemClasses = () =>
    clsx(
      'form-element',
      {
        'has-error': status === 'Error',
        'has-success': status === 'Success',
        'has-warning': status === 'Warning',
        'has-complete': status === 'Complete',
        'has-normal': status === 'Normal',
        'is-disabled': inputProps.disabled,
        'form-element_small': inputSize === 'Small',
        'has-floating-label': inputLabel && hasFloatingLabel,
      },
      formElementClassNames
    );

  return (
    <div data-theme={theme} className={formElemClasses()}>
      {/* Input Label for non-floating label variant */}
      {inputLabel && !hasFloatingLabel && (
        <label className='form-element__label' htmlFor={props.id}>
          {inputLabel}
        </label>
      )}

      <div className='form-element__control'>
        <div className='input-select__wrapper'>
          <select {...inputProps} className='input-select'>
            {options?.map((option: SelectOption, i) => (
              <option key={option.label ?? `option-${i}`} {...option}>
                {option.label}
              </option>
            ))}
          </select>
          {/* Input Label for floating label variant */}
          {inputLabel && hasFloatingLabel && (
            <label htmlFor={props.id}>{inputLabel}</label>
          )}
        </div>
      </div>

      {/* Hint Text */}
      {hintText && <div className='form-element__help'>{hintText}</div>}
    </div>
  );
};

export default Select;
